<template>
  <card
    @onRemoveItem="handleRemove"
    :item="item"
    model="year"
    :image="imagePath"
    :url="url"
    :user="user"
  >
    <CardItemList>
      <CardDetail
        label="Number of Groupings"
        :val="`${item.num_groupings} ${plural('Grouping', item.num_groupings)}`"
      />
      <CardDetail
        label="Number of Ponies"
        :val="`${item.num_ponies} ${plural('Pony', item.num_ponies)}`"
      />
    </CardItemList>
    <h3 class="card-details-title">Groupings:</h3>
    <CardItemList
      v-if="item.groupings && item.groupings.length"
      :items="item.groupings"
      model="grouping"
    />
  </card>
</template>

<script>
import { getImagePath, plural } from '../../utils/helpers';
import Card from '../Card/Card';
import CardItemList from '../CardItemList/CardItemList';
import CardDetail from '../CardDetail/CardDetail';

export default {
  name: 'YearCard',
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
    user: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    Card,
    CardItemList,
    CardDetail
  },
  computed: {
    imagePath() {
      return getImagePath(this.item?.image);
    },
    url() {
      return `/year/${this.item.slug}`;
    }
  },
  methods: {
    handleRemove() {
      this.$emit('onRemove', {slug: this.item.slug});
    },
    plural,
  }
};
</script>
